import { Question2 } from "@dsm/dsm-storybook";

export interface AnswerData {
  id: string;
  name: string;
  isSelected: boolean;
}

export interface QuestionWithAnswers<Type> {
  type: string;
  questionNumber: string;
  question: string;
  answers: Array<Type>;
  questionRef: Question2 | null;
  subQuestions: QuestionWithAnswers<Type>[];
}

export const riskAnalysisIncorrectValue = -1;
export interface RiskAnalysisItem {
  probability: number;
  severity: number;
  detectability: number;
}

export interface RiskAnalysisData {
  question: string;
  result: RiskAnalysisItem;
}

export interface RootCauseParam {
  failureAnswerId: string;
  projectPhaseId: string;
}

export interface ReportData {
  phase: string;
  rootCoosTitle: string;
  mitigations: string;
  failure: string;
}
